var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_501_28",
    "data-name": "Component 501 \\u2013 28",
    xmlns: "http://www.w3.org/2000/svg",
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1",
    "data-name": "Rectangle 1",
    width: 39,
    height: 39,
    rx: 19.5,
    fill: "#29e67c"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_62048",
    "data-name": "Path 62048",
    d: "M9.232,7.183V0H7.183V7.183H0V9.232H7.183v7.183H9.232V9.232h7.183V7.183Z",
    transform: "translate(11.292 11.292)",
    fill: "#404040"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/Add.9f0adf62ab8a621a4d3a1246ff28054d.svg";
export { ForwardRef as ReactComponent };